export default __webpack_public_path__ + "static/scanner-d7014bdfeea2e2fad74eac7f9d6fd5ba.png";